module.exports = __webpack_public_path__ + "static/media/agenda.cc535da9.png";